import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=55d3d3c8&"
import script from "TS/components/chat/chat.component.js?vue&type=script&lang=js&"
export * from "TS/components/chat/chat.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports